(function(){
  const header=document.querySelector('[data-site-header]');
  if(header){window.addEventListener('scroll',()=>{header.classList.toggle('scrolled',window.scrollY>18);});}

  const menuToggle=document.querySelector('[data-mobile-menu-toggle]');
  const mobilePanel=document.querySelector('[data-mobile-nav-panel]');
  if(menuToggle && mobilePanel){
    menuToggle.addEventListener('click',()=>{
      const isOpen=menuToggle.getAttribute('aria-expanded')==='true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      if(isOpen){ mobilePanel.setAttribute('hidden','hidden'); }
      else { mobilePanel.removeAttribute('hidden'); }
    });
    mobilePanel.querySelectorAll('a').forEach((a)=>a.addEventListener('click',()=>{
      menuToggle.setAttribute('aria-expanded','false');
      mobilePanel.setAttribute('hidden','hidden');
    }));
    window.addEventListener('resize',()=>{
      if(window.innerWidth>980){
        menuToggle.setAttribute('aria-expanded','false');
        mobilePanel.setAttribute('hidden','hidden');
      }
    });
  }

  const sliderWrap=document.querySelector('[data-featured-slider]');
  if(sliderWrap){
    const track=sliderWrap.querySelector('[data-featured-track]');
    const items=[...sliderWrap.querySelectorAll('[data-featured-item]')];
    const prev=sliderWrap.querySelector('[data-featured-prev]');
    const next=sliderWrap.querySelector('[data-featured-next]');
    const dotsHost=document.querySelector('[data-featured-dots]');
    if(track && items.length && dotsHost){
      const dots=items.map((_,i)=>{
        const b=document.createElement('button');
        b.type='button';
        b.setAttribute('aria-label',`Go to coral ${i+1}`);
        b.addEventListener('click',()=>track.scrollTo({left: items[i].offsetLeft, behavior:'smooth'}));
        dotsHost.appendChild(b);
        return b;
      });
      const sync=()=>{
        const idx=Math.round(track.scrollLeft / (items[0].offsetWidth + 14));
        dots.forEach((d,i)=>d.classList.toggle('active',i===Math.max(0,Math.min(items.length-1,idx))));
      };
      sync();
      track.addEventListener('scroll',sync,{passive:true});
      if(prev){prev.addEventListener('click',()=>track.scrollBy({left:-items[0].offsetWidth,behavior:'smooth'}));}
      if(next){next.addEventListener('click',()=>track.scrollBy({left:items[0].offsetWidth,behavior:'smooth'}));}
    }
  }

  const countdown=document.querySelector('[data-countdown]');
  if(countdown){
    const dateRaw=countdown.getAttribute('data-date');
    const note=countdown.querySelector('[data-countdown-note]');
    if(!dateRaw){ if(note) note.textContent='Set a countdown date in this section.'; return; }
    const target=new Date(dateRaw).getTime();
    if(Number.isNaN(target)){ if(note) note.textContent='Invalid countdown date format.'; return; }
    const el=(k)=>countdown.querySelector('[data-'+k+']');
    function tick(){
      const diff=864e5-(Date.now()-(Date.parse(new Date().toLocaleString("en-US",{timeZone:"UTC"}))-Date.parse(new Date().toLocaleString("en-US",{timeZone:"America/New_York"}))))%864e5;
      const d=Math.floor(diff/86400000), h=Math.floor((diff/3600000)%24), m=Math.floor((diff/60000)%60), s=Math.floor((diff/1000)%60);
      if(el('days')) el('days').textContent=String(d).padStart(2,'0');
      if(el('hours')) el('hours').textContent=String(h).padStart(2,'0');
      if(el('minutes')) el('minutes').textContent=String(m).padStart(2,'0');
      if(el('seconds')) el('seconds').textContent=String(s).padStart(2,'0');
      if(diff===0 && note) note.textContent='Drop is live now.';
    }
    tick(); setInterval(tick,1000);
  }
})();